
import { createActionTypeModel } from "../../../../store/global/action-model";
// Type Container for AccountsRoyalty Action/Mutation Types. Use it in   accounts/actions.js, accounts/mutations.js and the Vuex Host Component 
export const DistributionStatementsData = createActionTypeModel('DistributionStatementsData');
export const DistributionStatementsList = createActionTypeModel('DistributionStatementsList');
export const DistributionStatementsDetails = createActionTypeModel('DistributionStatementsDetails');
export const DistributionStatementsDetailsRefresh = createActionTypeModel('DistributionStatementsDetailsRefresh');
export const DistributionContact = createActionTypeModel('DistributionContact');
export const DistributionImportMatch = createActionTypeModel('DistributionImportMatch');
export const DistributionStatementImportSetup = createActionTypeModel('DistributionStatementImportSetup');
export const DistributionStatementSalesDetails = createActionTypeModel('DistributionStatementSalesDetails');
export const DistributionStatementImportResultDigital = createActionTypeModel('DistributionStatementImportResultDigital');
export const DistributionStatementFile = createActionTypeModel('DistributionStatementFile');
export const DistributionStatementCostImportMatch = createActionTypeModel('DistributionStatementCostImportMatch');

export const DistributionStatementImportResultTotal = createActionTypeModel('DistributionStatementImportResultTotal');


export const SET_DISTRIBUTION_STATEMENT_FILES = 'SET_DISTRIBUTION_STATEMENT_FILES';

export const SET_SELECTED_COLUMNS = 'SET_SELECTED_COLUMNS'